import { apiClient } from './client';
import { Classroom } from '../../types/api';

const BASE_URL = '/classrooms';

export interface ClassroomFilters {
  grade_id?: string;
  teacher_id?: string;
  academic_year?: number;
  limit?: number;
  skip?: number;
}

export interface ClassroomCreate {
  name: string;
  grade_id: string;
  teacher_id?: string;
  description?: string;
  capacity?: number;
  academic_year: number;
}

export interface ClassroomUpdate extends Partial<ClassroomCreate> {
  is_active?: boolean;
}

export interface ClassroomWithStats extends Classroom {
  grade_name?: string;
  stats: {
    total_children: number;
    total_observations: number;
    total_assessments: number;
    active_children: number;
  };
}

export const classroomsApi = {
  // Get classrooms
  async getClassrooms(filters: ClassroomFilters = {}): Promise<Classroom[]> {
    const response = await apiClient.get(`${BASE_URL}/`, { params: filters });
    return response.data;
  },

  // Get single classroom
  async getClassroom(classroomId: string): Promise<Classroom> {
    const response = await apiClient.get(`${BASE_URL}/${classroomId}`);
    return response.data;
  },

  // Create classroom
  async createClassroom(data: ClassroomCreate): Promise<Classroom> {
    const response = await apiClient.post(`${BASE_URL}/`, data);
    return response.data;
  },

  // Update classroom
  async updateClassroom(classroomId: string, data: ClassroomUpdate): Promise<Classroom> {
    const response = await apiClient.put(`${BASE_URL}/${classroomId}`, data);
    return response.data;
  },

  // Delete classroom
  async deleteClassroom(classroomId: string): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${classroomId}`);
  },

  // Get classroom statistics
  async getClassroomStats(classroomId: string): Promise<{
    total_children: number;
    total_observations: number;
    total_assessments: number;
    active_children: number;
  }> {
    const response = await apiClient.get(`${BASE_URL}/${classroomId}/stats`);
    return response.data;
  },

  // Get classrooms with statistics
  async getClassroomsWithStats(filters: ClassroomFilters = {}): Promise<ClassroomWithStats[]> {
    const response = await apiClient.get(`${BASE_URL}/with-stats`, { params: filters });
    return response.data;
  },
};